import {makeStyles} from '@material-ui/core';
import {getDirectionStyles} from '../../../../utils/ThemeUtils';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(5, '36px'),
        borderRadius: '4px'
    },
    gameName: {
        textTransform: 'capitalize'
    },
    gameIcon: {
        width: 'auto',
        height: 'auto',
        lineHeight: 0,
        paddingLeft: getDirectionStyles(theme.direction)(0, theme.spacing(2)),
        paddingRight: getDirectionStyles(theme.direction)(theme.spacing(2), 0),

        '& > img, & > svg': {
            width: '56px',
            height: '50px'
        }
    },
    chartHeader: {
        position: 'relative',
        display: 'flex',
        listStyleType: 'none',
        justifyContent: 'space-between',
        padding: 0,

        [theme.breakpoints.down('sm')]: {
            display: 'unset',

            '& li': {
                paddingBottom: theme.spacing(3)
            }
        },

        '& li': {
            '& span': {
                opacity: 0.6,
                letterSpacing: theme.typography.pxToRem(0.5),
                fontSize: theme.typography.pxToRem(14),
                textTransform: 'uppercase',

                [theme.breakpoints.up('xl')]: {
                    fontSize: theme.typography.pxToRem(11)
                }
            },

            '&:first-child': {
                flex: '0 0 35%',
                display: 'flex',
                alignItems: 'center',

                '& $gameIcon span': {
                    opacity: 1
                }
            },

            [theme.breakpoints.up('md')]: {
                '&:last-child': {
                    flex: '0 0 8%'
                }
            },

            [theme.breakpoints.up('xl')]: {
                '&:first-child': {
                    flex: '0 0 40%'
                },

                '&:last-child': {
                    flex: '0 0 4%'
                }
            }
        }
    },
    chartContent: {
        direction: 'ltr',
        paddingTop: theme.spacing(7),
        height: '445px',
        boxSizing: 'content-box',
        transition: 'max-height 0.3s ease-in-out',
        overflow: 'hidden',

        '& > span': {
            position: 'relative',
            left: '2em',
            top: '2em',
            zIndex: 1000
        },

        [theme.breakpoints.down('md')]: {
            paddingTop: theme.spacing(2)
        }
    },
    rechartsWrapper: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '75%',
            marginLeft: theme.spacing(2)
        }
    },
    emptyChart: {
        fill: theme.palette.common.white,
        opacity: 0.6,
        fontSize: theme.typography.pxToRem(14),
        letterSpacing: theme.typography.pxToRem(0.5),
        transform: 'translate(0, -270px)'
    }
}));

export default useStyles;
